var map = {
	"./Frame.svg": 10,
	"./about-loyalty.svg": 11,
	"./active-arrow.svg": 12,
	"./add_photo.svg": 13,
	"./affiliatedCompanies.svg": 14,
	"./api-key-created.svg": 15,
	"./api-key.svg": 16,
	"./arrow-asc-sort.svg": 17,
	"./arrow-back.svg": 18,
	"./arrow-bottom-dark.svg": 19,
	"./arrow-bottom.svg": 20,
	"./arrow-desc-sort.svg": 21,
	"./arrow-go.svg": 22,
	"./arrow-graph-down.svg": 23,
	"./arrow-graph-up.svg": 24,
	"./arrow-in-screen.svg": 25,
	"./arrow-left.svg": 26,
	"./arrow-no-sort.svg": 27,
	"./arrow-right.svg": 28,
	"./arrow-top-dark.svg": 29,
	"./arrow-vertical-dark.svg": 30,
	"./arrow-vertical.svg": 31,
	"./attach.svg": 32,
	"./bell.svg": 33,
	"./boxes.svg": 34,
	"./bulb.svg": 35,
	"./calculator-light.svg": 36,
	"./cargo-tarif.svg": 37,
	"./cart.svg": 38,
	"./check-read.svg": 39,
	"./checkmark.svg": 40,
	"./clip.svg": 41,
	"./contacts-menu.svg": 42,
	"./contract-bird-circle.svg": 43,
	"./contract-minus-circle.svg": 44,
	"./contract-warning-circle.svg": 45,
	"./contract-x-circle.svg": 46,
	"./contract_modal.svg": 47,
	"./contracts.svg": 48,
	"./copy.svg": 49,
	"./cross.svg": 50,
	"./customer.svg": 51,
	"./data-delivery.svg": 52,
	"./data-fence.svg": 53,
	"./data-info.svg": 54,
	"./data-receipt.svg": 55,
	"./declared-cost.svg": 56,
	"./delete.svg": 57,
	"./delivery-car.svg": 58,
	"./delivery-logo.svg": 59,
	"./delivery.svg": 60,
	"./disabled-arrow.svg": 61,
	"./document.svg": 62,
	"./documents_and_files.svg": 63,
	"./done_active-1.svg": 64,
	"./done_active.svg": 65,
	"./download-analitics.svg": 66,
	"./download.svg": 67,
	"./drag.svg": 68,
	"./dropzone-document.svg": 69,
	"./dropzone-pin.svg": 70,
	"./edit-tarif.svg": 71,
	"./edit_small.svg": 72,
	"./email.svg": 73,
	"./employees.svg": 74,
	"./eye-invisible.svg": 75,
	"./eye-svg.svg": 76,
	"./filter.svg": 77,
	"./fuel-coef.svg": 78,
	"./gear-in-screen.svg": 79,
	"./generated-evaluation.svg": 80,
	"./generated-receipt.svg": 81,
	"./gold-ring.svg": 82,
	"./graphic-analitics.svg": 83,
	"./head-bg.svg": 84,
	"./home-auto.svg": 85,
	"./home-cod.svg": 86,
	"./home-dispatch.svg": 87,
	"./home-invoices.svg": 88,
	"./home-orders.svg": 89,
	"./home-pay.svg": 90,
	"./home-receipt.svg": 91,
	"./home-receiving.svg": 92,
	"./home-ttn.svg": 93,
	"./icon-cards.svg": 94,
	"./icon-date.svg": 95,
	"./icon-filter.svg": 96,
	"./icon-stats.svg": 97,
	"./icon-table-max.svg": 98,
	"./icon-table-min.svg": 99,
	"./icon-table.svg": 100,
	"./icon-time.svg": 101,
	"./info.svg": 102,
	"./investigation.svg": 103,
	"./invoices.svg": 104,
	"./key.svg": 105,
	"./location.svg": 106,
	"./lock.svg": 107,
	"./loyalty.svg": 108,
	"./manager-analitics.svg": 109,
	"./minus.svg": 110,
	"./new-invoice-icon.svg": 111,
	"./notification.svg": 112,
	"./order-car-reverse.svg": 113,
	"./order-car.svg": 114,
	"./owner.svg": 115,
	"./pallet-tarif.svg": 116,
	"./parcel-route.svg": 117,
	"./payer-en.svg": 118,
	"./payer-ru.svg": 119,
	"./payer-uk.svg": 120,
	"./payer.svg": 121,
	"./payment-card.svg": 122,
	"./payment-cash.svg": 123,
	"./pdf.svg": 124,
	"./person.svg": 125,
	"./phone.svg": 126,
	"./plus-circle.svg": 127,
	"./plus.svg": 128,
	"./posilka-tarif.svg": 129,
	"./print.svg": 130,
	"./promocode.svg": 131,
	"./receipt.svg": 132,
	"./reciever-en.svg": 133,
	"./reciever-ru.svg": 134,
	"./reciever-uk.svg": 135,
	"./reciever.svg": 136,
	"./rubrics-0-0.svg": 137,
	"./rubrics-0-1.svg": 138,
	"./rubrics-0-2.svg": 139,
	"./rubrics-0-3.svg": 140,
	"./rubrics-0-4.svg": 141,
	"./rubrics-0-5.svg": 142,
	"./rubrics-0-6.svg": 143,
	"./rubrics-1-0.svg": 144,
	"./rubrics-1-1.svg": 145,
	"./rubrics-1-2.svg": 146,
	"./rubrics-1-3.svg": 147,
	"./rubrics-1-4.svg": 148,
	"./rubrics-1-5.svg": 149,
	"./rubrics-1-6.svg": 150,
	"./search.svg": 151,
	"./sender-en.svg": 152,
	"./sender-ru.svg": 153,
	"./sender-uk.svg": 154,
	"./sender.svg": 155,
	"./settings.svg": 156,
	"./speedometer-arrow.svg": 157,
	"./speedometer-bg.svg": 158,
	"./speedometer-separator.svg": 159,
	"./star-gray.svg": 160,
	"./star-orange.svg": 161,
	"./status-icon-four.svg": 162,
	"./status-icon-one.svg": 163,
	"./status-icon-three.svg": 164,
	"./status-icon-two.svg": 165,
	"./status-icon-zero.svg": 166,
	"./step-bg.svg": 167,
	"./subsidiaries.svg": 168,
	"./tarif-analitics.svg": 169,
	"./tg_Icon.svg": 170,
	"./thanks.svg": 171,
	"./ticket-payment-bird.svg": 172,
	"./user.svg": 173,
	"./vchasno.svg": 174,
	"./warehouse0.svg": 175,
	"./warehouse1.svg": 176,
	"./warehouse3.svg": 177
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9;